export default {
  'menu.settings.workflow': '審批流程',
  'menu.settings.businessProcess': '業務流程配置',
  'menu.funds.operations': '基金资金与运营',
  'menu.funds.disclosure': '基金备案与信息披露',
  'menu.funds.distribution': '收益分配与清算',
  'menu.home.overview': '概览',
  'menu.funds.overview': '概览',
  'menu.investment.overview': '概览',
  'menu.portfolio.overview': '概览',
  'menu.research.overview': '概览',
  'menu.portfolio.exit.overview': '概览',

  'menu.settings.investmentFlow': '業務流程與審批配置',
  'menu.settings.projectManagerRiskMapping': '責任經理與風控管理',
  'menu.settings.fundDictionary': '基金业务字典',
  'menu.settings.portfolioConfig': '投后业务配置',
  'menu.settings.exitConfig': '退出业务配置',
  'menu.settings.researchConfig': '投研业务配置',

  'menu.analysis.fundPerformance': '基金业绩',
  'menu.analysis.portfolioAnalysis': '组合分析',
  'menu.analysis.investmentAnalysis': '投资项目分析',
  'menu.analysis.exitAnalysis': '退出回收分析',

  'menu.home.myWorkbench': '工作台',
  'menu.home.tasks': '待办与审批',
  'menu.home.focus': '关注对象',
  'menu.home.schedule': '日程安排',
  'menu.home.activity': '动态',
  'menu.home.risk': '风险与履约',
  'menu.home.LP 基金': 'LP 基金',
  'menu.home.基金协作': '基金協作',
  'menu.analysis.overview': '概览',
  'menu.analysis.trace': '资金权益追溯',

  'menu.funds.总览': '總覽',
  'menu.funds.基金': '基金',
  'menu.funds.基金.基金列表': '基金列表',
  'menu.funds.基金.投资联动': '投資聯動',
  'menu.funds.基金.基金详情': '基金詳情',
  'menu.funds.主体档案': '主體檔案',
  'menu.funds.募资跟进': '募資跟進',
  'menu.funds.募资跟进.出资人跟进': '出資人跟進',
  'menu.funds.募资跟进.跟进详情': '跟進詳情',
  'menu.funds.投资者关系': '投資者關係',
  'menu.funds.投资者关系.投资人关系': '投資人關係',
  'menu.funds.投资者关系.LP披露': 'LP披露',
  'menu.funds.投资者关系.区域工作': '區域工作',
  'menu.funds.投资者关系.缴款台账': '繳款台帳',
  'menu.funds.投资者关系.投资人详情': '投資人詳情',
  'menu.funds.投资者关系.出资详情': '出資詳情',
  'menu.funds.缴款与到账': '認繳與實繳',
  'menu.funds.出资详情': '出資詳情',
  'menu.investment.概览': '概览',
  'menu.investment.项目线索': '资源池',
  'menu.investment.客户关系': '客户关系',
  'menu.investment.客户关系.客户': '客户',
  'menu.investment.客户关系.organizationDetail': 'organizationDetail',
  'menu.investment.客户关系.联系人': '联系人',
  'menu.investment.leadDetail': 'leadDetail',
  'menu.investment.投资项目': '投资项目',
  'menu.investment.projectDetail': 'projectDetail',
  'menu.investment.投资决策': '投资决策',
  'menu.investment.审批工作台': '审批工作台',
  'menu.investment.decisionDetail': 'decisionDetail',
  'menu.investment.交易与交割': '交易与交割',
  'menu.investment.transactionDetail': 'transactionDetail',
  'menu.investment.台账报表': '台帳報表',
  'menu.portfolio.概览': '概览',
  'menu.portfolio.投后管理': '投后管理',
  'menu.portfolio.投后项目': '投后项目',
  'menu.portfolio.投后管理.全部项目': '全部项目',
  'menu.portfolio.投后管理.我的项目': '我的项目',
  'menu.portfolio.投后管理.投后项目详情': '投后项目详情',
  'menu.portfolio.经营跟踪': '经营跟踪',
  'menu.portfolio.经营跟踪.经营看板': '经营看板',
  'menu.portfolio.经营跟踪.数据记录': '数据记录',
  'menu.portfolio.经营跟踪.记录详情': '记录详情',
  'menu.portfolio.风险与事项': '风险与事项',
  'menu.portfolio.风险与事项.风险台账': '风险台账',
  'menu.portfolio.风险与事项.风险详情': '风险详情',
  'menu.portfolio.风险与事项.重点事项': '重点事项',
  'menu.portfolio.风险与事项.事项详情': '事项详情',
  'menu.portfolio.定期报告': '定期报告',
  'menu.portfolio.定期报告.报告列表': '报告列表',
  'menu.portfolio.定期报告.报告详情': '报告详情',
  'menu.portfolio.exit.退出机会': '退出机会',
  'menu.portfolio.exit.机会详情': '机会详情',
  'menu.portfolio.exit.退出项目': '退出项目',
  'menu.portfolio.exit.项目详情': '项目详情',
  'menu.portfolio.exit.退出交易': '退出交易',
  'menu.portfolio.exit.交易详情': '交易详情',
  'menu.research.工作台': '工作台',
  'menu.research.产业研究': '产业研究',
  'menu.research.产业研究.产业专题': '产业专题',
  'menu.research.产业研究.研究资料': '研究资料',
  'menu.research.企业与标的': '企业与标的',
  'menu.research.机构与专家资源': '机构与专家资源',
  'menu.research.机构与专家资源.投资机构': '投资机构',
  'menu.research.机构与专家资源.专家': '专家',
  'menu.research.机构与专家资源.FA与服务机构': 'FA与服务机构',
  'menu.research.课题管理': '课题管理',
  'menu.research.课题管理.研究课题': '研究课题',
  'menu.数据看板': '数据看板',
  'menu.系统设置': '系统设置',
  'menu.系统设置.业务设置': '业务设置',
  'menu.设置': '设置',
  'menu.设置.业务字典': '业务字典',
  'menu.设置.业务配置': '业务配置',
  'menu.客户关系': '客户关系',
  'menu.客户关系.客户': '客户',
  'menu.客户关系.客户详情': '客户详情',
  'menu.客户关系.联系人': '联系人',
  'menu.home': '工作台',
  'menu.funds': '基金与募资',
  'menu.investment': '投资项目',
  'menu.portfolio': '投后与退出',
  'menu.portfolio.exit': '退出管理',
  'menu.research': '投研与资源',
  'menu.analysis': '分析与报告',
  'menu.settings.platform': '平台配置',
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.workItem': '我的待辦',
  'menu.schedule': '日程',
  'menu.focus': '重點關注',
  'menu.activity': '業務跟進與提醒',
  'menu.overview': '數據總覽',
  'menu.sourceDetail': '業務對象詳情',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.settings': '系統設置',
  'menu.settings.permissions': '權限管理',
  'menu.settings.modelSettings': '模型設定',
  'menu.settings.dictionaries': '業務字典',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
